/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Signin_InstructionsInputs */

const en_two_fa_signin_instructions = /** @type {(inputs: Two_Fa_Signin_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the code from your authenticator app.`)
};

const nl_two_fa_signin_instructions = /** @type {(inputs: Two_Fa_Signin_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer de code uit je authenticator-app in.`)
};

/**
* | output |
* | --- |
* | "Enter the code from your authenticator app." |
*
* @param {Two_Fa_Signin_InstructionsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_signin_instructions = /** @type {((inputs?: Two_Fa_Signin_InstructionsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Signin_InstructionsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_signin_instructions(inputs)
	return en_two_fa_signin_instructions(inputs)
});